<template>
  <v-layout wrap style="width: 256px;">
    <v-flex xs12>
      <v-card>
        <v-toolbar>
          <v-app-bar-nav-icon @click.stop="closedrawer()" ><v-icon style="color: #A80D00 !important;">menu</v-icon></v-app-bar-nav-icon>
          <img :src="BASE_URL + 'static/logo aed/aed12.svg'" alt="" width="200px" class="ml-4">
        </v-toolbar>
        <div style="height: calc(100vh - 64px); height: calc(calc(var(--vh, 1vh) * 100) - 64px);overflow: scroll;">
          <v-list-group v-for="item in itemsMenu2" >
            <template v-slot:activator style="background-color: #A80D00 !important; color: white !important;" class="headerBackground">
              <v-list-item-title style="background-color: #A80D00 !important; color: white !important; text-align: left !important;">{{item.title}}</v-list-item-title>
            </template>
            <v-list-item v-for="sub in item.subMenu" :class="(selected_homepage == sub.path)? 'selectF':'nonselectF'" @click="gotopath(sub)" v-if="checkRole(sub.role)">
              <v-list-item-icon>
                <img :src="sub.icon" width="40" v-if="sub.icon != ''">
                <v-avatar size="40" v-else style="background: #A80D00 !important;">
                  <v-icon style="font-size: 24px;">{{sub.icon2}}</v-icon>
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content > {{sub.title}} </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </div>
      </v-card>
    </v-flex>
    <CreateCompany :dialogcreate_company="dialogcreate_company" headid="" :typeCompany="typeCompany" @closecreate_company="closecreate_company"></CreateCompany>
  </v-layout>
</template>

<script>
import CreateCompany from '@/components/create/create_company_modal'
import { Decode } from '@/services'
let vh = window.innerHeight * 0.01;


export default {
  data () {
    return {
      msg: 'menu',
      BASE_URL: process.env.BASE_URL,
      dialogcreate_company: false,
      itemsMenuowner: [
        {
          title: 'Homepage',
          subMenu: [
            {
              title: 'หน้าแรก',
              path: '/homepage',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/home.svg'
            }
          ]
        },
        {
          title: 'Create Company',
          subMenu: [
            {
              title: 'บริษัทในเครือสภากาชาด',
              path: 'owner',
              modal: true,
              icon: '',
              icon2: 'fas fa-plus'
            },
            {
              title: 'บริษัทร่วมโครงการ',
              path: 'partner',
              modal: true,
              icon: process.env.BASE_URL + 'static/icon/building.svg'
            },
            {
              title: 'บริษัทบำรุงรักษาเครื่อง AED',
              path: 'maintenance',
              modal: true,
              icon: '',
              icon2: 'fas fa-tools'
            }
          ]
        },
        {
          title: 'Create Account',
          subMenu: [
            {
              title: 'บริษัทในเครือสภากาชาด',
              path: '/create_account?type=owner',
              modal: false,
              icon: '',
              icon2: 'fas fa-plus'
            },
            {
              title: 'บริษัทร่วมโครงการ',
              path: '/create_account?type=partner',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/building.svg'
            },
            {
              title: 'บริษัทบำรุงรักษาเครื่อง AED',
              path: '/create_maintenance',
              modal: false,
              icon: '',
              icon2: 'fas fa-tools'
            }
          ]
        },
        {
          title: 'QR Code',
          subMenu: [
            {
              title: 'สร้าง QR Code',
              path: '/genQrcode',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/qrcode.svg'
            }
          ]
        },
        {
          title: 'Report',
          subMenu: [
          {
              title: 'ข้อมูล admin',
              path: '/information/admin',
              modal: false,
              icon: '',
              icon2: 'fas fa-user-cog'
            },
            {
              title: 'ข้อมูล user',
              path: '/information/user?type=all',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/user.svg'
            },
            {
              title: 'ข้อมูล บริษัท',
              icon: process.env.BASE_URL + 'static/icon/building.svg',
              path: '/information/company?type=all',
              modal: false
            },
            {
              title: 'เครื่อง AED',
              icon: process.env.BASE_URL + 'static/icon/heart.svg',
              path: '/information/aed?typeSearch=all&page=1&search=',
              modal: false
            },
            {
              title: 'การขอความช่วยเหลือ',
              icon: '',
              icon: process.env.BASE_URL + 'static/icon/helping.svg',
              path: '/information/requestHelping',
              modal: false
            },
            {
              title: 'ประวัติใช้งานเครื่อง AED',
              icon: '',
              icon: process.env.BASE_URL + 'static/iconButton/history.svg',
              path: '/information/history_use?typeSearch=all&page=1&search=',
              modal: false
            },
            {
              title: 'แจ้งปัญหาการใช้งาน',
              icon: '',
              icon2: 'fas fa-tools',
              path: '/information/issue',
              modal: false
            },
            {
              title: 'ข้อมูล QR Code',
              icon: process.env.BASE_URL + 'static/icon/qrcode.svg',
              path: '/information/qrcode',
              modal: false
            }
          ]
        }
      ],
      itemsMenupartner: [
        {
          title: 'Homepage',
          subMenu: [
            {
              title: 'หน้าแรก',
              path: '/homepage',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/home.svg'
            }
          ]
        },
        {
          title: 'Create Company',
          subMenu: [
            {
              title: 'บริษัทบำรุงรักษาเครื่อง AED',
              path: 'maintenance',
              modal: true,
              icon: '',
              icon2: 'fas fa-tools'
            }
          ]
        },
        {
          title: 'Create Account',
          subMenu: [
            {
              title: 'บริษัทตนเอง',
              path: '/create_account?type=partner',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/building.svg'
            },
            {
              title: 'บริษัทบำรุงรักษาเครื่อง AED',
              path: '/create_maintenance',
              modal: false,
              icon: '',
              icon2: 'fas fa-tools'
            }
          ]
        },
        {
          title: 'QR Code',
          subMenu: [
            {
              title: 'สร้าง QR Code',
              path: '/genQrcode',
              modal: false,
              icon: process.env.BASE_URL + 'static/icon/qrcode.svg'
            }
          ]
        },
        {
          title: 'Report',
          subMenu: [
          {
              title: 'ข้อมูล admin',
              path: '/information/admin',
              modal: false,
              icon: '',
              icon2: 'fas fa-user-cog'
            },
            {
              title: 'เครื่อง AED',
              icon: process.env.BASE_URL + 'static/icon/heart.svg',
              path: '/information/aed',
              modal: false
            },
            {
              title: 'แจ้งปัญหาการใช้งาน',
              icon: '',
              icon2: 'fas fa-tools',
              path: '/information/issue',
              modal: false
            },
            {
              title: 'ข้อมูล QR Code',
              icon: process.env.BASE_URL + 'static/icon/qrcode.svg',
              path: '/information/qrcode',
              modal: false
            }
          ]
        }
      ],
      itemsMenu2: [],
      selected_homepage: '',
      typeCompany: '',
      role: '',
      authen: {},
      headerAPI: {}
    }
  },
  components: {
    CreateCompany
  },
  created () {
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.typeCompany = this.authen.typeCompany
    if (this.typeCompany == 'owner') {
      this.itemsMenu2 = this.itemsMenuowner
    } else if (this.typeCompany == 'partner') {
      this.itemsMenu2 = this.itemsMenupartner
    }
    this.headerAPI = {Authorization: this.authen.Authorization}
  },
  methods: {
    closedrawer () {
      this.$emit('closedrawer', false)
    },
    checkRole (role) {
      return true
      // return role.includes(this.typeCompany)
    },
    gotopath (data) {
      if (data.modal) {
        // console.log(data.modal)
        this.typeCompany = data.path
        this.dialogcreate_company = true
        this.closedrawer()
      } else {
        this.selected_homepage = data.path
        this.$router.replace(data.path)
        this.closedrawer()
      }
    },
    closecreate_company (value) {
      this.dialogcreate_company = value
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  >>>.v-list {
    list-style-type: none;
    padding: 0px 0;
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }
  >>>.v-toolbar__extension {
    webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    padding: 0 24px !important;
    align-items: center !important;
    justify-content: center !important;
  }
  >>>.v-list .v-list--subheader .theme--light {
    height: 0px !important;
  }
  .subheader {
    background-color: #A80D00 !important;
    color: white;
  }
  h1,h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .v-application--is-ltr .v-list-item__icon:first-child {
      margin-right: 12px !important;
  }
  .v-list-item__content {
    overflow: unset;
  }

  >>>.v-list-item--link  {
      background: #a80d00 !important;
  }
  >>>.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
      justify-content: center;
      color: white !important;
  }
  >>>.v-list-group--active>.v-list-group__header>.v-list-group__header__append-icon .v-icon {
    color: white !important;
  }
  >>>.v-icon.v-icon {
    color: white !important;
  }

  >>>.selectF {
    background-color: #ffcac747 !important;
    text-align: left !important;
    cursor: pointer !important;
  }
  >>>.nonselectF {
    background-color: white !important;
    text-align: left !important;
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/leftside.vue